import React from 'react'
import css from './card.module.scss'

export default ({ children }: React.PropsWithChildren) => (
  <tr className={css.title}>
    <td colSpan={2}>{children}</td>
  </tr>
)
